export default __webpack_public_path__ + "static/media/ITV_Policy_virus_prevention.06858329.png";